import React from "react";
import { CalendarPlus } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui-kit";
import { usePrefs } from "@/contexts/PrefsContext";

const gStamp = (iso: string) => new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

export const CalendarMenu = ({ eventId, title, start, end, location, className = "", tile = false }: {
  eventId: string; title: string; start: string; end: string; location: string; className?: string; tile?: boolean;
}) => {
  const { t, lang } = usePrefs();
  const link = `${window.location.origin}/events/${eventId}`;
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(`${title} — ${t("appName")}`)}&dates=${gStamp(start)}/${gStamp(end)}&details=${encodeURIComponent(link)}&location=${encodeURIComponent(location)}&ctz=Asia/Baghdad`;
  const ics = `${process.env.REACT_APP_BACKEND_URL}/api/events/${eventId}/calendar.ics?lang=${lang}`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`calendar-menu-${eventId}`} className={tile ? className : `h-11 px-4 rounded-full bg-accent font-bold text-sm inline-flex items-center justify-center gap-1.5 active:scale-95 transition-transform ${className}`}>
          <CalendarPlus className={tile ? "h-5 w-5" : "h-4 w-4"} />{tile ? <span>{t("cal.short")}</span> : t("cal.add")}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="rounded-2xl">
        <DropdownMenuItem asChild><a data-testid="calendar-google-link" href={google} target="_blank" rel="noreferrer">{t("cal.google")}</a></DropdownMenuItem>
        <DropdownMenuItem asChild><a data-testid="calendar-ics-link" href={ics} download>{t("cal.ics")}</a></DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
